import { render, staticRenderFns } from "./BankConnection.vue?vue&type=template&id=00679212&scoped=true&"
import script from "./BankConnection.vue?vue&type=script&lang=js&"
export * from "./BankConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00679212",
  null
  
)

export default component.exports